import PropTypes from 'prop-types';
import isNil from 'ramda/src/isNil';

import PropTypesPresenter from '../utils/PropTypesPresenter';
import UserPresenter from '../presenters/UserPresenter';
import { amountReadable } from '../utils/functions';

export const OPEN = 'open';
export const CLOSED = 'closed';
export const ALL = 'all';
export const PENDING = 'pending';
export const CLOSE = 'close';

export const STATES = {
  all: ALL,
  open: OPEN,
  closed: CLOSED,
  pending: PENDING,
};

export default new PropTypesPresenter(
  {
    id: PropTypes.number,
    amount: PropTypes.number,
    meta: PropTypes.shape(),
    date: PropTypes.string,
    fastCashId: PropTypes.number,
    institutionName: PropTypes.string,
    storeName: PropTypes.string,
    userEmail: PropTypes.string,
    userAuth0Id: PropTypes.string,
    reviewerComment: PropTypes.string,
    receipts: PropTypes.arrayOf(PropTypes.shape()),
    state: PropTypes.string,
    plaidTicketUrl: PropTypes.string,
    createdAt: PropTypes.string,
    user: UserPresenter.shape(),
  },
  {
    amountReadable(supportRequest) {
      const amount = this.amount(supportRequest);

      return amountReadable(amount);
    },
    reviewerCommentReadable(supportRequest) {
      const reviewerComment = this.reviewerComment(supportRequest);

      return reviewerComment || '--';
    },
    isOpen(supportRequest) {
      return this.state(supportRequest) === OPEN;
    },
    isPending(supportRequest) {
      return this.state(supportRequest) === PENDING;
    },
    plaidTicketUrlReadable(supportRequest) {
      const url = this.plaidTicketUrl(supportRequest);

      return url || '--';
    },
    hasReviewerComment(supportRequest) {
      const reviewerComment = this.reviewerComment(supportRequest);

      return !isNil(reviewerComment);
    },
  }
);
